import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getCarrierContactTableDetails = async (input) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_MASTER_SEARCH_SPOT";
  inputObj["Input"] = JSON.stringify(input);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const getCarrierMasterTableDetails = async (input) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "CARRIER_MASTER_SEARCH";
  inputObj["Input"] = JSON.stringify(input);
  props.input = inputObj;

  let result = await GatewayGet(props, props.input);
  // Manually assigning id for ChildScac

  // code changed 
  if (result['child'] !== undefined) {
    result = {...result, child: result['child'].map((cld) => ({...cld, id: Math.floor(Math.random() * 10000000)}))}
  } else {
    result = {...result, child: []};
  }
  return result;
};

export const getCurrencyDetails = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_CURR_CODES";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  let result = await GatewayGet(props, props.input);
  return result;
};